import pluralize from "pluralize";
import React from "react";

import { NOISEWORDS_PATTERN } from "../const/Patterns";
import { MESSAGES, SEARCH_STATUS } from "../const/SearchConsts";

import FilterToggle from "../components/filters/FilterToggle";

/* TODO: Move these somewhere else */
function toTitleCase(string, asArray) {
  const array = string
    .split(" ")
    .map(word => word.charAt(0).toUpperCase() + word.substr(1));

  return asArray ? array : array.join(" ");
}

function toSmartTitleCase(string) {
  const [firstWord, ...rest] = toTitleCase(string, true);
  const smartTitleCase = rest.join(" ").replace(NOISEWORDS_PATTERN, match => match.toLowerCase());

  return [firstWord, smartTitleCase].join(" ");
}
/* End move these somewhere else */

function getContent(props) {
  const { count, status, type } = props;
  let content = null;

  if (status === SEARCH_STATUS.ERROR) {
    content = MESSAGES.error;
  }

  if (status === SEARCH_STATUS.LOADING) {
    content = MESSAGES.loading.replace("$type", pluralize(type, 2));
  }

  if (status === SEARCH_STATUS.SUCCESS) {
    content = MESSAGES.results
      .replace("$count", pluralize(type, count, true))
      .replace("$match", count === 1 ? "matches" : "match");
  }

  return content;
}

class SearchHeader extends React.Component {
  className() {
    const { status } = this.props;

    return status === SEARCH_STATUS.SUCCESS ? null : status;
  }

  text() {
    const { location, status, type } = this.props;

    return !status || status === SEARCH_STATUS.LOADING
      ? "Searching..."
      : `Top ${pluralize(type, 2)} in ${location}`;
  }

  render() {
    const self = this;
    const className = self.className();
    const filtersContainer = document.getElementById("js-search-filters");
    const text = self.text();

    return (
      <React.Fragment>
        <h2 className={className} id="js-search-title">{toSmartTitleCase(text)}</h2>
        <p className={className}>
          {getContent(self.props)}{" "}
          <span id="js-search-filter-toggle"></span>
          {filtersContainer && <FilterToggle filters={filtersContainer} />}
        </p>
      </React.Fragment>
    );
  }
}

export default SearchHeader;



// WEBPACK FOOTER //
// ./providers/SearchHeader.jsx